<template>
  <transition name="fade">
    <div
      class="modal"
      v-if="isShowInsertVideo"
      style="z-index:1000;"
    >
      <div class="container">
        <div class="upload_top msp_icon_close">
          <span
            style="float:left;"
            v-if="uploadType==='video'"
          >插入视频</span>
          <span
            style="float:left;"
            v-if="uploadType==='audio'"
          >插入音频</span>
          <span
            class="iconfont el-icon-close"
            style="float:right;font-size:20px;cursor:pointer;line-height:44px;"
            @click.stop='closeInsertVideoBox()'
          ></span>
        </div>
        <div class="headimg_type">
          <el-tabs
            v-model="activeName"
            type="card"
            @tab-click="handleClick"
          >
            <el-tab-pane
              label="本地上传"
              name="fromLocal"
            >本地上传</el-tab-pane>
            <el-tab-pane
              label="素材库插入"
              name="fromMaterial"
            >素材库插入</el-tab-pane>

            <el-tab-pane
              label="链接插入"
              name="fromOuterLink"
            >链接插入</el-tab-pane>

          </el-tabs>
        </div>
        <div
          v-show="activeName === 'fromOuterLink'"
          style='width:100%;'
        >
          <div class="play_linkurl">
            <span>播放链接</span>
            <el-input
              placeholder="请输入播放链接"
              v-model="playLinkUrl"
            ></el-input>
          </div>

          <div
            class="play_linkurl"
            v-if="uploadType==='video'"
          >
            <span>通用代码</span>
            <el-input
              placeholder="请输入通用代码"
              v-model="codeLinkUrl"
            ></el-input>
          </div>

        </div>

        <div
          v-show="activeName === 'fromLocal'"
          class="insert_video"
        >
          <input
            style="display:none;"
            type="file"
            multiple="multiple"
            id="fileMoreUpSend"
            name="file"
            @change="onFileMoreUpSend($event)"
          >
          <div class="matter_local">
            <div class="matter_local_content">
              <div class="upload_matter_button">
                <el-button
                  v-if="!isUploadIng && uploadType==='video'"
                  type="primary"
                  round
                  @click.native="uploadMatter()"
                >添加视频</el-button>
                <el-button
                  v-if="!isUploadIng && uploadType==='audio'"
                  type="primary"
                  round
                  @click.native="uploadMatter()"
                >添加音频</el-button>
                <span :title="fileAllName.name">{{ fileAllName.name }}</span>
              </div>

              <div class="upload_progress">
                <el-progress
                  :text-inside="true"
                  :stroke-width="24"
                  :percentage="progressBar"
                  status="success"
                ></el-progress>
              </div>
              <div class="upload_matter_button save_matter">
                <el-button
                  v-if="!isUploadIng"
                  type="primary"
                  style="height:32px;width:110px;padding:0;"
                  @click.stop="choiceMatterPosition()"
                >保存至媒资库</el-button>
                <span style="line-height:32px;">{{ currendFolderPosition.currentFolderLocation }}</span>
              </div>
              <div
                class="upload_each_info_detail upload_input_info_detail"
                style="padding-left:68px;margin-bottom:10px;"
              >
                <span class="star">*</span>
                <span>素材名称：</span>
                <el-input
                  v-model="uploadPicObj.title"
                  placeholder="请输入素材名称"
                  :disabled='isUploadIng'
                ></el-input>
              </div>
              <div
                class="upload_each_info_detail"
                style="margin-bottom:10px;"
              >
                <span>上&nbsp;&nbsp;传&nbsp;&nbsp;者：</span>
                <span class="need_textdot">{{ username }}</span>
              </div>
              <div class="upload_each_info_detail upload_input_tags_detail">
                <span>素材标签：</span>
                <el-cascader
                  v-model="uploadPicObj.tagIds"
                  :options="matterTagsTree"
                  :props='cascaderProps'
                  :size='cascaderSize'
                  :show-all-levels="false"
                  ref='cascaderref'
                  filterable
                  :disabled='isUploadIng'
                  @change="handleChange"
                ></el-cascader>
              </div>
              <div class="upload_each_info_detail">
                <span>关&nbsp;&nbsp;键&nbsp;&nbsp;词：</span>
                <div class="key_words">
                  <el-tag
                    :key="tag"
                    v-for="tag in uploadPicObj.keywords"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)"
                  >
                    {{tag}}
                  </el-tag>
                  <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    maxlength="10"
                    :disabled='isUploadIng'
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                  >
                  </el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    :disabled='isUploadIng'
                    @click="showInput"
                  >+ 添加关键词</el-button>
                </div>
              </div>
              <div class="upload_each_info_detail upload_input_info_detail">
                <span>素材描述：</span>
                <el-input
                  type="textarea"
                  placeholder="请填写内容"
                  v-model="uploadPicObj.detail"
                  :disabled='isUploadIng'
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div
          v-show="activeName === 'fromMaterial' && uploadType==='video'"
          class="insert_video"
        >
          <div class="insert_video_repo">
            <repotree
              @folderClick='handleNodeClick'
              :isHidePersonRepo='true'
            ></repotree>
          </div>
          <div
            class="nodata_pic"
            v-show='videoList.length==0'
          >
            <img
              src="../../../static/img/nodata.png"
              alt=""
            />
            <div>空空如也。。。</div>
          </div>
          <div
            class="insert_video_list"
            v-loading='videoloading'
            element-loading-text="拼命加载中"
          >
            <el-scrollbar
              class="insert_material_video"
              v-show='videoList.length>0'
            >
              <ul>
                <li
                  v-for="(item,index) in videoList"
                  :key="index"
                  @click.stop='lookinfoVideo(item)'
                >
                  <img
                    :src="item.cover_img"
                    alt=""
                    class="video_coverimg"
                    v-if="item.cover_img"
                  >
                  <img
                    src="../../../static/img/media.png"
                    alt=""
                    v-if='!item.cover_img'
                  >
                  <img
                    src="../../../static/img/videoplay.png"
                    alt=""
                    class="video_playimg"
                    style="cursor:pointer;"
                  >

                  <div
                    class="video_title"
                    :title="item.title"
                  >
                    <span>{{item.title}}</span>
                  </div>

                  <div class="video_each_status">
                    <div class="each_status">
                      <span
                        v-if="item.flag_sign_and_issue"
                        class="yes"
                      >已签发</span>
                      <span
                        v-if="!item.flag_sign_and_issue"
                        class="unAudit"
                      >未签发</span>
                    </div>
                    <div class="each_status">
                      <span
                        v-if="item.flag_push === 'yes'"
                        class="yes"
                      >已推送</span>
                      <span
                        v-if="item.flag_push === 'no'"
                        class="unAudit"
                      >未推送</span>
                    </div>
                    <div class="each_status">
                      <span
                        v-if="item.audit_status === 'yes'"
                        class="yes"
                      >已通过</span>
                      <span
                        v-if="item.audit_status === 'no'"
                        class="no"
                      >未通过</span>
                      <span
                        v-if="item.audit_status === 'doing'"
                        class="doing"
                      >审核中</span>

                      <span
                        v-if="item.audit_status === 'unAudit'"
                        class="unAudit"
                      >未审核</span>
                    </div>
                  </div>

                  <div
                    class="choice_current_video"
                    :class='[currentInsertVideo.id === item.id ? "choice_current_videoActive" : ""]'
                    @click.stop='choiceCurrenInsertVideo($event,item)'
                  >
                    <span class="el-icon-check"></span>
                  </div>

                </li>

              </ul>
            </el-scrollbar>
          </div>
        </div>

        <div
          class="insert_video"
          v-show="activeName === 'fromMaterial' && uploadType==='audio'"
        >
          <div class="insert_video_repo">
            <repotree
              @folderClick='handleNodeClick'
              :isHidePersonRepo='true'
            ></repotree>
          </div>
          <div
            class="nodata_pic"
            v-show='videoList.length==0'
          >
            <img
              src="../../../static/img/nodata.png"
              alt=""
            />
            <div>空空如也。。。</div>
          </div>
          <div
            class="insert_video_list"
            v-loading='videoloading'
            element-loading-text="拼命加载中"
          >
            <el-scrollbar
              class="insert_material_audio"
              v-show='videoList.length>0'
            >
              <ul class="materialaudio_list">
                <li v-for='item in videoList'>
                  <div
                    class="material_audio_name"
                    style="flex:1;"
                  >
                    <img
                      src="../../../static/img/audio.png"
                      alt=""
                    />
                    <span class="audio_file_name">{{item.file_name}}</span>
                    <div class="operate_audio">
                      <span
                        class="iconfont icon-yulan1"
                        title="预览"
                        @click.stop='previewAudio(item)'
                      ></span>
                      <span
                        class="iconfont icon-charu"
                        title="插入"
                        style="font-size:20px;"
                        @click.stop='insertEditorAudioUrl(item)'
                      ></span>
                    </div>
                  </div>

                </li>
              </ul>

            </el-scrollbar>
          </div>
        </div>

        <div
          v-show="activeName === 'fromMaterial'"
          class="page_pagenation"
        >
          <el-pagination
            :current-page.sync="currentPage"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next, jumper"
            :total="videoAllTotal"
          >
          </el-pagination>
        </div>
        <div class="sure_btn">
          <el-button
            type="primary"
            @click.native='choiceVideoIssueUrl()'
          >确定</el-button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import * as api from '../../../api'
import repotree from '../repotree/repotree'
import logsMixins from '../../../mixins/logs'
import Vue from 'vue'
export default {
  components: {
    repotree
  },

  created () {


  },

  mounted () {
    this.$root.eventHub.$on('insertVideoModel', (data, mspoption, type) => {
      this.uploadType = type
      this.uploadPicObj.type = type
      this.editorIns = data
      this.isShowInsertVideo = true
      if (mspoption.keywords) {
        this.uploadPicObj.keywords = JSON.parse(JSON.stringify(mspoption.keywords))
      }
      this.getLastFolderChoice()
    })

    this.$root.eventHub.$on('getCurrentFolderModel', (data) => {
      this.currendFolderPosition = data
      this.uploadPicObj.repoId = data.id_repo
      this.uploadPicObj.folderId = data.id
    })

  },

  updated () {

  },
  destroyed () {
    this.$root.eventHub.$off('insertVideoModel')
    this.$root.eventHub.$off('getCurrentFolderModel')
  },

  data () {
    return {
      videoList: [],
      currentFolder: '',
      videoAllTotal: 0,
      currentPage: 1,
      currentInsertVideo: '',
      isShowInsertVideo: false,
      videoloading: false,
      editorIns: '',
      activeName: 'fromLocal',

      currendFolderPosition: '',
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        multiple: true,
        emitPath: false,
        checkStrictly: true,
        expandTrigger: 'hover'
      },
      cascaderSize: 'medium',
      keywords: [],
      inputVisible: false,
      inputValue: '',
      fileAllName: '',
      uploadPicObj: {
        'repoId': '', // 必须参数： 库 ID
        'folderId': '', // 必须参数： 文件夹 ID
        'type': 'video', // 必须参数： 附件类型, 视频: video  音频: audio
        'vodId': '', // 必须参数： 音频或视频 ID
        'title': '', // 必须参数： 标题
        'fileName': '', // 必须参数： 文件名
        'tagIds': [], // 必须参数： 标签ID列表
        'tags': [], // 必须参数： 标签列表
        'keywords': [], // 必须参数： 关键词列表
        'detail': '',  // 必须参数： 标题
        'origin_url': '',
        'file_name': '',
        'files': ''
      },
      aliyunData: '',
      progressBar: 0,
      isUploadIng: false,
      pageSize: 10,
      videoAudioUploader: null,
      playLinkUrl: "",
      codeLinkUrl: '',
      uploadType: 'video'
    }
  },
  mixins: [logsMixins],
  computed: {
    username () {
      return this.$store.state.userinfo.username
    },
    matterTagsTree () {
      return this.$store.state.tags.matterTagsTree
    }

  },

  methods: {
    closeInsertVideoBox () {
      if (this.videoAudioUploader) {
        this.videoAudioUploader.cancelFile(0)
        this.videoAudioUploader.cleanList()
        this.$notify.warning({
          title: '警告',
          message: '上传已取消'
        })
        this.getUploadVideoInfoError()
      }
      this.isShowInsertVideo = false
    },

    handleNodeClick (data) {
      this.currentFolder = data
      if (!data.flag_repo) {
        this.currentPage = 1
        this.getVideoList(0, data)
      }

    },
    getVideoList (pagenow, data) {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                       // 必须字段： 创建文章参数
          'sortTime': 'time_update', // 排序时间（创建时间：time_create | 更新时间:time_update）
          'sortRule': 'desc', // 排序规则（正序:asc | 倒叙: desc）
          'definition': '', // 清晰度（高清:high|标清:standard）
          'composition': 'all', // 构图（全部:all/横图:heng/竖图:shu/方图:fang）
          'widthAndHigh': 0,
          'width': 0,
          'height': 0,
          'format': '',
          'startSize': '',
          'endSize': '',
          'flag_issue': 'all', // 签发状态 全部：all  已签：yes，未签：no
          'flag_push': 'all', // 推送状态： 全部：all  已推送：yes  未推送：no
          'flag_audit': 'all', // 审核状态： 全部：all  已审核：yes  未审核：no  审核中： doing
          'folderId': data.id,
          'type': this.uploadType, // 素材类型：图片 picture 视频 video 音频 audio  附件 file
          'tags': [], // 标签
          'searchValue': '',
          'searchType': 'all',
          'pageSize': this.pageSize,
          'pageNum': pagenow,
          'startTime': '',
          'endTime': ''
        }
      }
      this.videoloading = true
      this.currentPage = pagenow + 1
      api._post(_VIDEOAUDIOURL_ + 'public/pageQuery', option).then((res) => {
        if (res.code == 200) {
          try {
            this.videoAllTotal = res.data.totalElements
            this.videoList = res.data.content
          } catch (e) {
            this.videoAllTotal = 0
            this.videoList = []
          }
        } else {
          this.videoAllTotal = 0
          this.videoList = []
        }
        this.videoloading = false
      }).catch((error) => {
        console.log(error)
        this.videoloading = false
      })

    },
    handleCurrentChange (page) {
      if (!(this.currentFolder.flag_repo)) {
        this.getVideoList(page - 1, this.currentFolder)
      }
    },
    choiceCurrenInsertVideo (event, item) {
      this.currentInsertVideo = item
    },
    choiceVideoIssueUrl () {
      if (this.activeName === 'fromLocal') {
        if (this.uploadPicObj.title !== '' && this.fileAllName !== '' && this.uploadPicObj.repoId !== '' && this.uploadPicObj.folderId !== '') {
          var option = {
            ...this.$store.getters.baseOption,
            'params': this.uploadPicObj
          }
          this.isUploadIng = true
          api._post(_VIDEOAUDIOURL_ + 'uploader/get_sts_info', option).then((resp) => {
            if (resp.code === 200) {
              this.aliyunData = resp.data
              this.uploadPicObj.vodId = resp.data.videoId
              this.videoAudioUploader = this.createVideoAudioUploader(resp.data)
              if (this.videoAudioUploader) {
                this.selectFile(this.videoAudioUploader)
                this.videoAudioUploader.startUpload()
              }

            } else {
              this.isUploadIng = false
              this.$notify.error({
                title: '失败',
                message: '获取认证信息失败'
              })
            }
          }).catch((error) => {
            console.log(error)
            this.isUploadIng = false
            this.$notify.error({
              title: '失败',
              message: '获取认证信息失败'
            })
          })
        } else {
          this.$notify.warning({
            title: '警告',
            message: '请补全信息'
          })
        }
      } else if (this.activeName === 'fromOuterLink') {
        if (this.playLinkUrl) {
          if (this.uploadType === 'video') {
            var htmlStr = "<video controls='controls' webkit-playsinline='true' playsinline x5-video-player-type='h5' src='" + this.playLinkUrl + "' width='600px' poster='" + '' + "'></video>"
            this.editorIns.insertVideo(htmlStr)
          } else if (this.uploadType === 'audio') {
            this.editorIns.insertMeidaAudio(this.playLinkUrl)
          }
          if (!this.codeLinkUrl) {
            this.isUploadIng = false
            this.isShowInsertVideo = false
          }
        }
        if (this.codeLinkUrl) {
          this.editorIns.editor.selection.restore()
          this.editorIns.insertContent(this.codeLinkUrl)
          this.isUploadIng = false
          this.isShowInsertVideo = false
        }

      } else {
        if (this.uploadType === 'video') {
          if (this.currentInsertVideo) {
            if (this.currentInsertVideo.flag_sign_and_issue) {
              this.getUploadAfterVideoUrl(this.currentInsertVideo)
            } else {
              this.$confirm('插入未签发的视频至稿件中后，推送稿件时会自动签发该视频并记录；仍要继续插入未签发的视频吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.getUploadAfterVideoUrl(this.currentInsertVideo)
              }).catch(() => {
                console.log('取消')
              })
            }

          } else {
            this.$notify.warning({
              title: '警告',
              message: '请选择一个视频'
            });
          }
        } else {
          this.isUploadIng = false
          this.isShowInsertVideo = false
        }

      }
    },
    lookinfoVideo (item) {
      this.$root.eventHub.$emit('getMatterDetail', item, 'videoDetail')
    },


    handleClick (tab, event) {

    },
    // 本地上传

    handleChange (val) {
      var node = this.$refs.cascaderref.getCheckedNodes()
      var tags = []
      for (var i = 0; i < node.length; i++) {
        for (var j = 0; j < this.uploadPicObj.tagIds.length; j++) {
          if (node[i].value === this.uploadPicObj.tagIds[j]) {
            tags.push(node[i].label)
          }
        }
      }
      this.uploadPicObj.tags = tags
    },
    handleClose (tag) {
      this.uploadPicObj.keywords.splice(this.uploadPicObj.keywords.indexOf(tag), 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.uploadPicObj.keywords.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    choiceMatterPosition () {
      this.$root.eventHub.$emit('setMatterPositionModel', this.currendFolderPosition, 'matterPosition')
    },
    uploadMatter () {
      var fileName = document.getElementById('fileMoreUpSend')
      fileName.click()
    },
    onFileMoreUpSend (event) {
      var files = event.target.files || event.srcElement.files

      var fileExt = files[0].name.substr(files[0].name.lastIndexOf('.')).toLowerCase() // 获得文件后缀名
      var videoArr = ['.3gp', '.asf', '.avi', '.dat', '.dv', '.flv', '.f4v', '.gif', '.m2t', '.m4v', '.mj2', '.mjpeg', '.mkv', '.mov', '.mp4', '.mpe', '.mpg', '.mpeg', '.mts', '.ogg', '.qt', '.rm', '.rmvb', '.swf', '.ts', '.vob', '.wmv', '.webm']
      var audioArr = ['.mp3']
      this.uploadPicObj.fileName = files[0].name
      this.uploadPicObj.file_name = files[0].name
      this.uploadPicObj.files = files[0]
      if (this.uploadType === 'video') {
        var k = 0
        for (var i = 0; i < videoArr.length; i++) {
          if (videoArr[i] !== fileExt) {
            k++
          } else {
            break
          }
        }
        if (k === videoArr.length) {
          this.$notify.warning({
            title: '警告',
            message: '您上传的视频格式不对哦'
          })
        } else {
          this.fileAllName = files[0]
          var posiNum = this.fileAllName.name.lastIndexOf('.')
          if (posiNum !== -1) {
            this.uploadPicObj.title = this.fileAllName.name.substring(0, posiNum)
          } else {
            this.uploadPicObj.title = this.fileAllName.name
          }
        }
      } else if (this.uploadType === 'audio') {
        var n = 0
        for (var j = 0; j < audioArr.length; j++) {
          if (audioArr[j] !== fileExt) {
            n++
          } else {
            break
          }
        }
        if (n === audioArr.length) {
          this.$notify.warning({
            title: '警告',
            message: '您上传的音频格式不对哦，目前只支持MP3格式的音频！'
          })
        } else {
          this.fileAllName = files[0]
          var posiNumAudio = this.fileAllName.name.lastIndexOf('.')
          if (posiNumAudio !== -1) {
            this.uploadPicObj.title = this.fileAllName.name.substring(0, posiNumAudio)
          } else {
            this.uploadPicObj.title = this.fileAllName.name
          }
        }

      }

    },
    isVodMode () {
      var uploadAuth = this.aliyunData.uploadAuth
      return (uploadAuth && uploadAuth.length > 0)
    },

    isSTSMode () {
      var secretToken = this.aliyunData.securityToken
      if (!this.isVodMode()) {
        if (secretToken && secretToken.length > 0) {
          return true
        }
      }
      return false
    },
    selectFile (uploader) {
      var endpoint = ''
      var bucket = ''
      var objectPre = ''
      var userData
      if (this.isVodMode()) {
        userData = '{"Vod":{"StorageLocation":"","UserData":{"IsShowWaterMark":"false","Priority":"7"}}}'
      } else {
        userData = '{"Vod":{"StorageLocation":"","Title":"this is title.我是标题","Description":"this is desc.我是描述","CateId":"19","Tags":"tag1,tag2,标签3"}}'
      }
      if (this.isVodMode()) {
        // 点播上传。每次上传都是独立的OSS object，所以添加文件时，不需要设置OSS的属性
        uploader.addFile(this.fileAllName, null, null, null, userData)
      } else if (this.isSTSMode()) {
        // STS的上传方式，需要在userData里指定Title
        var object = objectPre
        // if(objectPre)
        // {
        //     object = objectPre +"/"+ event.target.files[i].name;
        // }
        uploader.addFile(this.fileAllName, endpoint, bucket, object, userData)
      }
    },

    createVideoAudioUploader (videoInfo) {
      var accessKeyId = videoInfo.accessKeyId
      var accessKeySecret = videoInfo.accessKeySecret
      var secretToken = videoInfo.securityToken
      var self = this
      var uploader = new AliyunUpload.Vod({
        // 文件上传失败
        'onUploadFailed': function (uploadInfo, code, message) {
          self.getUploadVideoInfoError()
        },
        // 文件上传完成
        'onUploadSucceed': function (uploadInfo) {
          self.show = false
          self.getUploadVideoInfoAfter()
        },
        // 文件上传进度
        'onUploadProgress': function (uploadInfo, totalSize, loadedPercent) {
          // log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + (loadedPercent * 100.00).toFixed(2) + "%");
          self.progressBar = Number((loadedPercent * 100.00).toFixed(2))
        },
        // STS临时账号会过期，过期时触发函数
        'onUploadTokenExpired': function (uploadInfo) {
          if (self.isVodMode()) {
            self.getUploadVideoInfoError()
            // 实现时，根据uploadInfo.videoId从新获取UploadAuth
            // 实际环境中调用点播的刷新上传凭证接口，获取凭证
            // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
            // 获取上传凭证后，调用setUploadAuthAndAddress
            // uploader.resumeUploadWithAuth(uploadAuth);
          } else if (self.isSTSMode()) {
            self.getUploadVideoInfoError()
            // 实现时，从新获取STS临时账号用于恢复上传
            // uploader.resumeUploadWithSTSToken(accessKeyId, accessKeySecret, secretToken, expireTime);
          }
        },
        onUploadCanceled: function (uploadInfo) {
          console.log('onUploadCanceled:file:' + uploadInfo.file.name)
        },
        // 开始上传
        'onUploadstarted': function (uploadInfo) {
          if (self.isVodMode()) {
            if (!uploadInfo.videoId) // 这个文件没有上传异常
            {
              // mock 上传凭证，实际产品中需要通过接口获取
              var uploadAuth = videoInfo.uploadAuth
              var uploadAddress = videoInfo.uploadAddress
              var videoId = videoInfo.videoId
              // 实际环境中调用调用点播的获取上传凭证接口
              // https://help.aliyun.com/document_detail/55407.html?spm=a2c4g.11186623.6.629.CH7i3X
              // 获取上传凭证后，调用setUploadAuthAndAddress
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId);
            } else // 如果videoId有值，根据videoId刷新上传凭证
            {
              // mock 上传凭证 实际产品中需要通过接口获取
              var uploadAuth = videoInfo.uploadAuth;
              var uploadAddress = videoInfo.uploadAddress
              // 实际环境中调用点播的刷新上传凭证接口，获取凭证
              // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
              // 获取上传凭证后，调用setUploadAuthAndAddress
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress)
            }
          }
          else if (self.isSTSMode()) {
            var accessKeyId = videoInfo.accessKeyId
            var accessKeySecret = videoInfo.accessKeySecret
            var secretToken = videoInfo.securityToken
            uploader.setSTSToken(uploadInfo, accessKeyId, accessKeySecret, secretToken)
          }
          console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
        },
        'onUploadEnd': function (uploadInfo) {
          console.log("onUploadEnd: uploaded all the files");
        }
      })
      return uploader
    },
    getUploadVideoInfoError () {
      if (this.videoAudioUploader) {
        var option = {
          ...this.$store.getters.baseOption,
          'params': this.uploadPicObj
        }
        api._post(_VIDEOAUDIOURL_ + 'uploader/error_confirm', option).then((resp) => {
          if (resp.code === 200) {
            this.$notify.error({
              title: '上传失败',
              message: '上传失败'
            })
          }
          this.isUploadIng = false
        }).catch((error) => {
          console.log(error)
          this.isUploadIng = false
        })
      }

    },

    getUploadVideoInfoAfter () {
      if (this.videoAudioUploader) {
        var option = {
          ...this.$store.getters.baseOption,
          'params': this.uploadPicObj
        }
        api._post(_VIDEOAUDIOURL_ + 'uploader/complete_confirm', option).then((resp) => {
          if (resp.code === 200) {
            this.$notify.success({
              title: '成功',
              message: '上传成功'
            })
            this.getUploadAfterVideoUrl(resp.data)
          }
        }).catch((error) => {
          console.log(error)
          this.isUploadIng = false
        })
      }
    },
    getUploadAfterVideoUrl (data) {
      if ((this.uploadType === 'video') || (this.uploadType === 'audio' && data.id_vod)) {
        this.videoloading = true
        var option = {
          ...this.$store.getters.baseOption,
          'params': {
            'id': data.id,
          }
        }
        api._post(_VIDEOAUDIOURL_ + 'av/video/internal_video_url', option).then((resp) => {
          if (resp.code === 200) {
            if (resp.data) {
              if (this.uploadType === 'video') {
                var htmlStr = "<video controls='controls' webkit-playsinline='true' playsinline x5-video-player-type='h5' src='" + resp.data.videoUrl + "' width='600px' poster='" + resp.data.posterUrl + "'></video>"
                this.editorIns.insertVideo(htmlStr)
              } else if (this.uploadType === 'audio') {
                this.editorIns.insertMeidaAudio(resp.data.videoUrl)
              }
              this.isUploadIng = false
              this.isShowInsertVideo = false
            }
          }
          this.videoloading = false
        }).catch((error) => {
          console.log(error)
          this.isUploadIng = false
          this.videoloading = false
        })

      } else if (this.uploadType === 'audio' && !data.id_vod) {
        this.editorIns.insertMeidaAudio(data.url)
        this.isUploadIng = false
        this.videoloading = false
        this.isShowInsertVideo = false
      }

    },
    insertEditorAudioUrl (item) {
      this.getUploadAfterVideoUrl(item)
    },
    previewAudio (item) {
      this.$root.eventHub.$emit('getMatterDetail', item, 'audioDetail')
    }

  },
  watch: {
    isShowInsertVideo () {
      if (this.isShowInsertVideo == false) {
        this.currentInsertVideo = ''
        this.videoList = []
        this.currentFolder = ''
        this.videoAllTotal = 0
        this.currentPage = 1
        this.progressBar = 0
        var fileName = document.getElementById('fileMoreUpSend')
        fileName.value = ''
        this.fileAllName = ''
        this.isUploadIng = false
        this.aliyunData = ''
        this.inputValue = ''
        this.videoAudioUploader = null
        this.currendFolderPosition = ''
        this.activeName = 'fromLocal'
        this.uploadPicObj = {
          'repoId': '', // 必须参数： 库 ID
          'folderId': '', // 必须参数： 文件夹 ID
          'type': 'video', // 必须参数： 附件类型, 视频: video  音频: audio
          'vodId': '', // 必须参数： 音频或视频 ID
          'title': '', // 必须参数： 标题
          'fileName': '', // 必须参数： 文件名
          'tagIds': [], // 必须参数： 标签ID列表
          'tags': [], // 必须参数： 标签列表
          'keywords': [], // 必须参数： 关键词列表
          'detail': '', // 必须参数： 标题
          'origin_url': '',
          'file_name': '',
          'files': ''
        }
        this.playLinkUrl = ""
        this.codeLinkUrl = ''
      }
    }
  }
}

</script>

<style scoped>
.container {
  transition: all 1s ease;
  width: 60%;
  height: 80%;
  background-color: #ffffff;
  box-shadow: 0px 0px 5px #999;
  border-radius: 5px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.upload_top {
  width: 100%;
  height: 44px;
  line-height: 44px;
  background: #f7faff;
  border-bottom: 1px solid #c0beff;
  clear: both;
  padding: 0 20px 0 20px;
  box-sizing: border-box;
}
.upload_top span {
  color: #333333;
  font-size: 14px;
}

.headimg_type {
  height: 38px;
  border-top: 1px solid #e6e7eb;
  background: #f0f1f3;
}

.insert_video {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  height: calc(100% - 84px);
}
.insert_video_repo {
  width: 250px;
  height: 100%;
  box-sizing: border-box;
  border-right: 1px solid #e8e8e8;
}
.insert_video_list {
  flex: 1;
  height: 100%;
  position: relative;
}
.page_pagenation {
  position: absolute;
  bottom: 20px;
  left: 270px;
}
.insert_material_video {
  height: 88%;
}
.insert_material_video ul {
  width: 100%;
  height: 100%;
  clear: both;
}
.insert_material_video ul li {
  width: 254px;
  height: 220px;
  float: left;
  margin-left: 20px;
  margin-bottom: 50px;
  background: #424242;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.insert_material_video ul li .video_coverimg {
  display: block;
  max-width: 254px;
  max-height: 220px;
}
.insert_material_video ul li .video_playimg {
  position: absolute;
  left: 87px;
  top: 70px;
}
.insert_material_video ul li .video_each_status {
  position: absolute;
  right: 0;
  top: 0;
}
.insert_material_video ul li .video_each_status .each_status {
  margin-bottom: 4px;
}

.insert_material_video ul li .video_each_status .each_status span {
  display: inline-block;
  padding: 5px 10px;
  color: #fff;
  font-size: 14px;
}

.insert_material_video ul li .video_each_status .each_status .yes {
  background: #6bd57c;
}

.insert_material_video ul li .video_each_status .each_status .no {
  background: #f56969;
}

.insert_material_video ul li .video_each_status .each_status .doing {
  background: #ffad2f;
}

.insert_material_video ul li .video_each_status .each_status .unAudit {
  background: #aaa;
}

.insert_material_video ul li .video_title {
  position: absolute;
  bottom: -20px;
  left: 0;
  width: 100%;
  color: #303133;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  text-align: center;
}

.choice_current_video {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 0;
  top: 0;
  background: #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #688eff;
}

.choice_current_video span {
  color: #fff;
  font-size: 12px;
  display: none;
}
.choice_current_videoActive {
  background: #688eff;
}
.choice_current_videoActive span {
  display: block;
}
.sure_btn {
  clear: both;
  position: absolute;
  bottom: 20px;
  right: 20px;
  box-sizing: border-box;
}
.sure_btn button {
  width: 74px;
  height: 32px;
  padding: 0px;
  line-height: 32px;
  text-align: center;
}
.nodata_pic {
  position: absolute;
  left: 56%;
  top: 40%;
}
.nodata_pic div {
  color: #333;
  font-size: 20px;
  padding-left: 20px;
  box-sizing: border-box;
}
.matter_local {
  width: 100%;
  height: 90%;
  display: flex;
  justify-content: center;
  padding-top: 10px;
  overflow: auto;
}

.upload_matter_button,
.save_matter {
  display: flex;
  padding: 14px 0 20px 76px;
}

.upload_matter_button button {
  margin-right: 10px;
  padding: 0;
  width: 110px;
  height: 38px;
}

.upload_matter_button span {
  display: inline-block;
  overflow: hidden;
  width: 300px;
  color: #606266;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 38px;
}

.matter_local_content .upload_progress {
  margin-bottom: 10px;
  padding-left: 77px;
  width: 480px;
  height: 24px;
  box-sizing: border-box;
}
.matter_local_content .save_matter span {
  color: #688eff;
}
.upload_each_info_detail {
  display: flex;
  box-sizing: border-box;
  margin-bottom: 20px;
  padding-left: 77px;
}
.upload_each_info_detail span {
  color: #606266;
  font-size: 14px;
  line-height: 36px;
}
.upload_each_info_detail .need_textdot {
  display: inline-block;
  overflow: hidden;
  width: 76%;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload_each_info_detail .key_words {
  box-sizing: border-box;
  padding: 10px 10px 10px 10px;
  min-height: 80px;
  width: 330px;
  border: 1px solid #dbe0ec;
  border-radius: 4px;
  background: #f7f8fa;
}

.upload_input_info_detail .star,
.upload_input_tags_detail .star {
  color: #f56969;
  margin-right: 4px;
}

.play_linkurl {
  display: flex;
  margin-top: 30px;
  width: 100%;
  padding-right: 30px;
  padding-left: 30px;
  box-sizing: border-box;
}
.play_linkurl span {
  width: 90px;
  line-height: 40px;
  display: inline-block;
}
.insert_material_audio {
  height: 88%;
}
.materialaudio_list {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
}

.materialaudio_list li {
  width: 100%;
  height: 60px;
  display: flex;
  border-bottom: 1px solid #c8c8c8;
  cursor: pointer;
  padding-right: 20px;
  box-sizing: border-box;
}

.material_audio_name {
  height: 60px;
  display: flex;
  clear: both;
  align-items: center;
  position: relative;
}

.material_audio_size {
  justify-content: center;
}
.material_audio_name span {
  color: #333333;
  font-size: 14px;
}
.material_audio_name img {
  display: block;
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.materialaudio_list li:hover {
  background-color: rgba(246, 250, 255, 1);
}
.materialaudio_list .audio_file_name {
  display: inline-block;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.operate_audio {
  height: 60px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  display: none;
  align-items: center;
}

.operate_audio .iconfont {
  color: #b5b8d9;
  font-size: 18px;
  cursor: pointer;
  margin-left: 20px;
  box-sizing: border-box;
}

.materialaudio_list li:hover .operate_audio {
  display: flex;
}
</style>
